<template>
    <input type="checkbox" @change="change()" />
</template>

<script>

export default {
    name: 'QwixxPenaltyButton',
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    methods: {
        change: function() {
            this.$store.commit('togglePenalty', this.id);
        }
    }
}

</script>

<style scoped>

input {
    margin: 0;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    border: .5vw solid var(--nord3);
    border-radius: 50%;
    background: var(--nord6);
}
input:checked {
    background: var(--nord6) url(/img/times-solid.svg) no-repeat center;
}

</style>
